import SignalEventList from "./SignalsEventList";
import withSignalEventsTracking from "./withSignalEventsTracking";

const SignalEventListTracked = withSignalEventsTracking(SignalEventList);

export default SignalEventListTracked;
